import Vue from 'vue/dist/vue.esm.js';
import passwordForm from "../mixin/password_form.js"

window.onload = function(){
  var passwordForUser = new Vue({
    data: {
      user: {
        email: "",
        password: "",
        passwordConfirmation: "",
      }
    },
    el: "#password_for_user",
    mixins: [passwordForm]
  })
}